import React from 'react';

import './stats.scss';
import AgentStats from './AgentStats';
import useStats from 'hooks/redux/useStats';
import useHasFeature, { AppFeatures } from 'hooks/useHasFeature';

import RealTimeContacts from './RealTimeContacts';
import { useDispatch, useSelector } from 'react-redux';
import RootState from 'store/state';
import { setMetricFilters } from 'store/metrics/metrics.actions';
import QueueMetrics from 'views/Metrics/RealTimeMetrics/QueueMetrics';

interface Props {}

const Stats: React.FC<Props> = () => {
    const filters = useSelector<RootState, RootState['metrics']['filters']>(state => state.metrics.filters);

    useStats();

    const hasFeature = useHasFeature();
    const dispatch = useDispatch();
    const hasCallPluckingFeature = hasFeature(AppFeatures.CALL_PLUCKING);

    const defaultClass = 'stats';
    const cssClass = hasCallPluckingFeature ? `${defaultClass} no-flex` : defaultClass;

    return (
        <div className={cssClass}>
            {hasCallPluckingFeature && <RealTimeContacts />}
            {hasFeature(AppFeatures.QUEUE_STATS) && (
                <>
                    <QueueMetrics
                        filters={filters}
                        onFilterChange={filters => dispatch(setMetricFilters(filters))}
                    />
                    <AgentStats />
                </>
            )}
        </div>
    );
};

export default Stats;
